import { useTranslation } from 'react-i18next';
import { NavLink, useLocation } from 'react-router';

import {
  type ContentRenderer,
  type LinkRenderer,
  renderNavNodes,
  SidebarDesktop,
  SidebarMobile,
} from '@valwin/facto/widgets';

import { LogoHorizontal } from '~shared/ui';

import { useNavigationItems } from './useNavigationItems';

const linkRenderer: LinkRenderer = (to) => {
  const NavLinkRenderer: ContentRenderer = (content) => (
    <NavLink to={to}>{content}</NavLink>
  );

  return NavLinkRenderer;
};

export function SidebarNavDesktop() {
  const { t } = useTranslation();
  const { pathname } = useLocation();
  const items = useNavigationItems();

  return (
    <SidebarDesktop.Root>
      <SidebarDesktop.Menu>
        {renderNavNodes({ nodes: items, pathname, renderLink: linkRenderer })}
      </SidebarDesktop.Menu>
      <SidebarDesktop.Footer
        expandLabel={t('sidebar expand')}
        collapseLabel={t('sidebar collapse')}
      />
    </SidebarDesktop.Root>
  );
}

export function SidebarNavMobile() {
  const { pathname } = useLocation();
  const items = useNavigationItems();

  return (
    <SidebarMobile
      nodes={items}
      pathname={pathname}
      renderLink={linkRenderer}
      logo={<LogoHorizontal />}
    />
  );
}
